import React from 'react';

import useProductProtectionPlans from 'data-hooks/useProductProtectionPlans';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductPrice from 'data-hooks/useProductPrice';
import usePDPAddProtectionPlanEvent from 'data-hooks/useEvents/usePDPAddProtectionPlanEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPProtectionPlanSelectorUI from './PDPProtectionPlanSelectorUI';
import useSetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useSetPdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';

function getPrice(percentage, priceData) {
  if (priceData.price?.original_price) {
    return Math.round(
      ((priceData.optionPrice + priceData.price.original_price) * percentage) /
        100
    );
  }
  return null;
}

const PDPProtectionPlanSelectorInner = () => {
  const { loading } = usePDPBasicDetails();

  const {
    loading: protectionPlanLoading,
    data: protectionPlansData,
  } = useProductProtectionPlans();

  const {
    data: { allProtectionPlanTypes },
  } = usePDPOptions();

  const setSelectedProtectionPlanId = useSetPdpSelectedProtectionPlanId();

  const { data: priceData } = useProductPrice();
  const { addProtectionPlanEvent } = usePDPAddProtectionPlanEvent();
  const allPlans = allProtectionPlanTypes
    ? allProtectionPlanTypes.map(plan => ({
        ...plan,
        plan_price: getPrice(plan?.plan_percent || 0, priceData || {}),
      }))
    : [];
  return protectionPlansData?.meta?.eligible_protection_planids?.length > 0 ? (
    <PDPProtectionPlanSelectorUI
      allProtectionPlanTypes={allPlans}
      loading={loading && protectionPlanLoading}
      meta={protectionPlansData?.meta}
      onProtectionPlanSelection={planId => {
        setSelectedProtectionPlanId(planId);
        const selectedPlan = allPlans.find(p => p.plan_id === planId);
        if (selectedPlan) {
          addProtectionPlanEvent(selectedPlan);
        }
      }}
    />
  ) : null;
};

const PDPProtectionPlanSelector = props => (
  <SuspenseWithLoader fallback={<PDPProtectionPlanSelectorUI loading />}>
    <PDPProtectionPlanSelectorInner {...props} />
  </SuspenseWithLoader>
);

export default PDPProtectionPlanSelector;
